"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.setupPaymentEndpoints = void 0;
var utils_1 = require("../utils");
var getBasePath = (0, utils_1.getBasePathFactory)('/payment');
function setupPaymentEndpoints(api) {
    return api.injectEndpoints({
        endpoints: function (build) { return ({
            getTransactionHistory: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/history");
                }
            }),
            getTransactionDetails: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, paymentId = _a.paymentId;
                    return "".concat(getBasePath(customerId), "/").concat(paymentId);
                }
            }),
            getReschedulePaymentOptions: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, paymentId = _a.paymentId;
                    return "".concat(getBasePath(customerId), "/").concat(paymentId, "/reschedule-options");
                }
            }),
            getPaymentStatus: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, _b = _a.history, history = _b === void 0 ? false : _b, overrideBillAmount = _a.overrideBillAmount, generalizedSchedule = _a.generalizedSchedule, isOverwriteRepaymentDate = _a.isOverwriteRepaymentDate, isUseLatestBillerAccountId = _a.isUseLatestBillerAccountId, isEnableOverlimitPreview = _a.isEnableOverlimitPreview;
                    return "".concat(getBasePath(customerId), "/status?is_full_history=").concat(history).concat(overrideBillAmount ? "&override_estimated_bill_amount_cent=".concat(overrideBillAmount) : '').concat(generalizedSchedule ? '&generalized_schedule=true' : '').concat(isOverwriteRepaymentDate ? "&is_overwrite_repayment_date=".concat(isOverwriteRepaymentDate) : '').concat(isUseLatestBillerAccountId ? "&is_use_latest_biller_account_id=".concat(isUseLatestBillerAccountId) : '').concat(isEnableOverlimitPreview ? "&is_enable_overlimit_preview=".concat(isEnableOverlimitPreview) : '');
                }
            }),
            reschedulePayment: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, paymentId = _a.paymentId, body = __rest(_a, ["customerId", "paymentId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/").concat(paymentId, "/reschedule"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            paymentEligibility: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, paymentId = _a.paymentId, delinquent = _a.delinquent;
                    return delinquent
                        ? "".concat(getBasePath(customerId), "/balance/eligibility")
                        : "".concat(getBasePath(customerId), "/").concat(paymentId, "/charge/eligibility");
                }
            }),
            paymentBreakdown: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, paymentId = _a.paymentId, delinquent = _a.delinquent, body = __rest(_a, ["customerId", "paymentId", "delinquent"]);
                    return ({
                        url: delinquent
                            ? "".concat(getBasePath(customerId), "/balance/breakdown")
                            : "".concat(getBasePath(customerId), "/").concat(paymentId, "/charge/breakdown"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            makePayment: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, paymentId = _a.paymentId, delinquent = _a.delinquent, body = __rest(_a, ["customerId", "paymentId", "delinquent"]);
                    return ({
                        url: delinquent ? "".concat(getBasePath(customerId), "/balance") : "".concat(getBasePath(customerId), "/").concat(paymentId, "/charge"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            getSuggestPaymentDate: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, body = __rest(_a, ["customerId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/suggest-payment-date"),
                        method: 'GET',
                        params: { date: body.date }
                    });
                }
            })
        }); }
    });
}
exports.setupPaymentEndpoints = setupPaymentEndpoints;
